import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import styles from './PlanSummaryCardV2.css';

function PlanSummaryCardV2({ concernLabel, chapterLabel }) {
    return (
        <div className={styles.root}>
            <div className={styles.item}>
                <span className={styles.iconBox}>
                    <Icon name='clock' className={styles.icon} />
                </span>
                <div>
                    <p className={styles.label}>Your concern</p>
                    <p className={styles.value}>{concernLabel}</p>
                </div>
            </div>
            <span className={styles.divider} />
            <div className={styles.item}>
                <span className={styles.iconBox}>
                    <Icon name='book' className={styles.icon} />
                </span>
                <div>
                    <p className={styles.label}>First chapter</p>
                    <p className={styles.value}>{chapterLabel}</p>
                </div>
            </div>
        </div>
    );
}

PlanSummaryCardV2.propTypes = {
    concernLabel: PropTypes.string,
    chapterLabel: PropTypes.string
};

export {
    PlanSummaryCardV2
};
